import { ActivatedRouteSnapshot } from '@angular/router';
import { TOpEntityType } from '../shared/typings/types/entity-type.types';

export interface INetworkClusterContext {
  entityType: TOpEntityType | null;
  networkId: string | null;
}

/**
 * Reads the network context out of the snapshot being activated.
 *
 * The walk covers both placements. On the legacy `network` tree the cluster-scoped guards run from
 * the `school/:clusterId` and `shelter/:clusterId` routes, so `clusterType` and `clusterId` are on
 * the snapshot itself and the first pass reads them. The OP matcher sets `clusterId` on its own
 * snapshot the same way. A guard handed an ancestor still resolves, since params are inherited
 * downward and never up.
 */
export function resolveNetworkClusterContext (snapshot: ActivatedRouteSnapshot): INetworkClusterContext {
  let entityType: TOpEntityType | null = null;
  let networkId: string | null = null;
  let current = snapshot;

  while (current) {
    entityType = entityType || (current.data?.clusterType as TOpEntityType) || null;
    networkId = networkId || current.params?.clusterId || current.params?.networkId || null;
    current = current.firstChild;
  }

  return { entityType, networkId };
}
